import script from "./HeaderCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCategories.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCategories.vue?vue&type=style&index=0&id=4a71e14a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a71e14a"]])

export default __exports__